import { EventUserDetailUser } from "@models/data-contracts";
import BaseUserProfileViewModel from "@domains/common/viewModel/BaseUserProfileViewModel";

class AttendedUserViewModel extends BaseUserProfileViewModel {
  eventUserId?: number;
  nickName?: string;
  hasAttended?: boolean;

  static create(responseData: EventUserDetailUser) {
    const participant = new AttendedUserViewModel({
      ...responseData,
      name: responseData.nickName,
    });

    participant.eventUserId = responseData.id;
    participant.nickName = responseData.nickName;
    participant.hasAttended = responseData.status === "Y";

    return participant;
  }
}

export default AttendedUserViewModel;
